import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { MainNavItemsService } from '../../services/main-nav-items.service';

@Component({
  selector: 'sh-main-nav-platform-items-mobile',
  templateUrl: './main-nav-platform-items-mobile.component.html',
  styleUrl: './main-nav-platform-items-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavPlatformItemsMobileComponent {
  @Output() closeMenu = new EventEmitter();

  constructor(public items: MainNavItemsService) {}

  onCloseMenu() {
    this.closeMenu.emit();
  }
}
